import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './audienceForm';
import List from './audienceList';

const settings = {
    pathRegister: paths.audienceRegister,
    pathList: paths.audience,
    apiPath: 'audiences',
    permissionAdmin: null,
    title: 'Audiência',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={{ ...settings, title: 'Audiências' }} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
